/* eslint-disable react-hooks/exhaustive-deps */
import { h } from 'preact';
import PropTypes from 'prop-types';

import { getLabel } from '../../../../labels/labelling-service';
import { parseWPNOptionsForSelectBox } from '../../../utils/parsers';
import Cta from '../../2-atoms/cta/cta';
import DropdownFloating from '../../3-molecules/dropdown/dropdown-floating';
import SelectBox from '../../3-molecules/select-box/select-box';

const WPNDialog = ({
  title,
  selectBoxes,
  onOptionClick,
  onClose,
  onConfirm,
  onUnsubscribe,
  selectedOptions = {},
  onSwitchClick,
}) => {
  const isSelectedOptionsEmpty = !Object.values(selectedOptions).reduce((prev, curr) => [...prev, ...curr], []).length;

  return (
    <div className="c-wpn-dialog">
      <div className="c-wpn-dialog__header">
        {onUnsubscribe && (
          <div className="c-wpn-dialog__dropdown">
            <DropdownFloating
              options={[
                {
                  text: getLabel('wpn.unsubscribe.title'),
                  onClick: onUnsubscribe,
                },
              ]}
            />
          </div>
        )}
        <button type="button" className="c-cta--close" onClick={onClose}>
          <div>
            <div />
          </div>
        </button>
      </div>
      <div className="c-wpn-dialog__body">
        <h3 className="c-wpn-dialog__title">{title}</h3>
        {selectBoxes.map((selectBox) => {
          return (
            <SelectBox
              {...selectBox}
              options={parseWPNOptionsForSelectBox(selectBox.options, selectedOptions[selectBox.boxName])}
              key={selectBox.boxName}
              selectedOptions={selectedOptions[selectBox.boxName]}
              onOptionClick={(option) => onOptionClick(selectBox.boxName, option)}
              onSwitchClick={(checked) => onSwitchClick(selectBox, checked)}
            />
          );
        })}
      </div>
      <div className="c-wpn-dialog__footer">
        <Cta tag="button" modifiers={['no-outline']} onClick={onClose}>
          {getLabel('global.cancel')}
        </Cta>
        <Cta tag="button" modifiers={['no-outline']} onClick={onConfirm} disabled={isSelectedOptionsEmpty}>
          {getLabel('global.confirm')}
        </Cta>
      </div>
    </div>
  );
};

WPNDialog.propTypes = {
  title: PropTypes.string.isRequired,
  selectBoxes: PropTypes.array.isRequired,
  onOptionClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onUnsubscribe: PropTypes.func,
  selectedOptions: PropTypes.object,
  onSwitchClick: PropTypes.func,
};

export default WPNDialog;
